// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1NiU2","amount":"Amount_amount__3BTEi","tip":"Amount_tip__37h32","tipHeader":"Amount_tipHeader__j6_A0","tipsWrap":"Amount_tipsWrap__3nNeA"};